import isEmpty from "lodash/isEmpty";
import { useFiltersV2Select } from "PFApp/components/filters_v2";
import { useLastUsedFilters } from "PFApp/components/filters_v2/hooks/use_last_used_filters";
import { FiltersV2Data } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { areFilterValuesEmpty } from "PFCore/helpers/filters";
import { FilterV2WithValueOnly } from "PFTypes/filters_v2";
import { useMemo } from "react";

export const useFiltersDataForApiCall = ():
  | FiltersV2Data<FilterV2WithValueOnly>
  | FiltersV2Data
  | undefined => {
  const { persistent, areChildrenOn, childrenFilters, mainFilters, initialFilters } = useFiltersV2Select(
    "persistent",
    "areChildrenOn",
    "childrenFilters",
    "mainFilters",
    "initialFilters"
  );
  const { lastUsedFilters } = useLastUsedFilters();

  return useMemo(() => {
    if (!isEmpty(mainFilters)) {
      return {
        mainFilters,
        childrenFilters,
        areChildrenOn
      };
    }

    if (initialFilters) {
      return {
        childrenFilters: {},
        ...(initialFilters || {}),
        areChildrenOn: !areFilterValuesEmpty(initialFilters?.childrenFilters || {})
      };
    }

    if (persistent && lastUsedFilters) {
      return lastUsedFilters;
    }

    return undefined;
  }, [areChildrenOn, childrenFilters, initialFilters, lastUsedFilters, mainFilters, persistent]);
};
